/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import {useState} from "react";
import ky from "ky";
const CreateCategoryDialog = ({ open, setOpen}) => {
    const [title,setTitle] = React.useState("")
    const [file, setFile] = useState(null)
    const HandleFileChange = (e) => {
        console.log(e.target.files)
      const file= e.target.files[0]

        if (file) {
            setFile(file)
        }
    }
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Создать категорию</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                       Введите данные для создания категории
                    </DialogContentText>
                    <TextField fullWidth margin="normal" id="filled-basic" label="Название категории" value={title}  onChange={(event)=>{setTitle(event.target.value)}} variant="filled" />
                   <br/>
                    <input type='file' onChange={(event)=>{HandleFileChange(event)}} accept='.png'/>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={()=>{
                        console.log(file.filename)
                        console.log(file.name)
                        const fd = new FormData();
                        fd.append("photo",file)
                        const data = SendPhoto(fd, file.name);
                        CreateCategory(title,`${data.id}.png`)



                        setOpen(false)
                    }}>Создать</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
const SendPhoto = (FormData, filename) =>{
    return axios.post(`https://photoapi.gigagile.space/upload`, FormData)
        .then((response) => {
            console.log(response)

            // Do something with the response from the backend
        })
        .catch((error) => {
            console.error('Error uploading file:', error);
        });
}
const CreateCategory = (titleInput, categoryInput) => {

        const json =  ky.post('https://kudiyarapi.gigagile.space/category', {
            title: titleInput,
            icon: categoryInput

        }).json();
}
export default CreateCategoryDialog

